import React from "react";
import "./Getinvolved.css";
import HeroSection from "../../components/HeroSection/HeroSection";
import GetInvolvedImage from "../../assets/images/getinvolved.jpg";
import Marquee from "react-fast-marquee";
import FloatImg1 from "../../assets/images/floatImg1.jpeg";
import Carpenter from "../../assets/images/carpenter.jpeg";
// Import company logos

import becomepartner from "../../assets/images/become-partners.webp";

import CompanyLogo1 from "../../assets/images/companylogo1.svg";
import CompanyLogo2 from "../../assets/images/companylogo2.svg";
import CompanyLogo3 from "../../assets/images/companylogo3.svg";
import CompanyLogo4 from "../../assets/images/companylogo4.svg";
import CompanyLogo5 from "../../assets/images/companylogo5.svg";
import CompanyLogo6 from "../../assets/images/companylogo6.svg";

import { RiDoubleQuotesL } from "react-icons/ri";
import { RiDoubleQuotesR } from "react-icons/ri";
import { motion } from "framer-motion";
import Footer from "../../components/Footer";

import leadingImage from "../../assets/images/leading.jpg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick"; // Make sure this is imported
import enterpriseLeads from "../../assets/images/enterpriseLeads.avif";
import expandReachImage from "../../assets/images/expand-reach.png";

import { BsPeople } from "react-icons/bs";
import { IoBusinessOutline } from "react-icons/io5";
import { AiOutlineFileSearch } from "react-icons/ai";
import hiring from "../../assets/images/hiring.png";

import businessman from "../../assets/images/businessman.png";

import earning from "../../assets/images/earning.png";

import trainer from "../../assets/images/trainer.png";
import { IoIosArrowRoundForward } from "react-icons/io";
import Srvicestestimonial from "../../components/ServicesTestimonial/Srvicestestimonial";
import BlogsTestimonial from "../../components/Blogs/blogs";

import { useEffect, useState } from "react";

const GetInvolved = () => {
  // Define company logos for the scrolling marquee
  const companyLogos = [
    CompanyLogo1,
    CompanyLogo2,
    CompanyLogo3,
    CompanyLogo4,
    CompanyLogo5,
    CompanyLogo6,
  ];

  const reviews = [
    { name: "John Doe", feedback: "Great service and quality!" },
    { name: "Emma Smith", feedback: "Absolutely loved it!" },
    { name: "Liam Johnson", feedback: "Highly recommend to everyone!" },
    { name: "Sophia Williams", feedback: "Wonderful experience!" },
    { name: "Noah Brown", feedback: "Amazing customer service!" },
    { name: "Olivia Taylor", feedback: "Best decision I ever made!" },
    { name: "Mason Lee", feedback: "Very professional and efficient!" },
    { name: "Ava Wilson", feedback: "Exceeded my expectations!" },
  ];

  const [currentIndex1, setCurrentIndex1] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <div className="involved-container">
      <div className="hero-section">
        <HeroSection
          className="hero-section"
          title="Get Involved"
          text="Join us in making a difference"
          heroImg={GetInvolvedImage}
          buttonText="Join Now"
          url="/getinvolved"
          btnClass="show"
        />
      </div>
      <div className="get-involved-section">
        <h4>GET INVOLVED </h4>
        <p>
          "Getting involved means becoming a part of a community that drives
          positive change. Whether through collaboration, support, or active
          participation, your contribution can make a real impact.Join us in
          shaping a better future together!"
        </p>
      </div>
      <div className="get-involved-container">
        <div className="get-involved-left-div">
          <div className="get-involved-left-div">
            <div className="become-partner">
              <img
                src={becomepartner}
                alt="Become a Partner"
                className="partner-image"
              />
            </div>
          </div>{" "}
          <div className="pipe-container">
            <div className="pipe-1"></div>
            <div className="pipe-2"></div>
          </div>
        </div>
        <div className="get-involved-right-div">
          <h2>PARTNER WITH US</h2>
          <h4>
            Building More Business <br />
            <span>Competitive</span>
          </h4>
          <RiDoubleQuotesL />

          <p>
            Partner with us and be a part of a growing network that fosters
            creativity, innovation, and impact. By joining hands, we can create
            meaningful opportunities that benefit both organizations.{" "}
          </p>
          <RiDoubleQuotesR className="quote-right" />
          <button className="join-partner-btn">Join As Partner</button>
        </div>
      </div>
      <div className="partners-section-wrapper text-center bg-emerald-950 py-24 px-4">
        {/* Animate the h3 text with a new class name */}
        <motion.h3
          className="partner-animation-heading text-5xl text-yellow-50" // New class name for the animated text
          initial={{ opacity: 0, y: 30 }} // Start position (invisible, shifted down)
          whileInView={{ opacity: 1, y: 0 }} // End position (fully visible, no shift)
          transition={{ duration: 1, ease: "easeInOut" }} // Smooth transition
        >
          We Work with the Best !
        </motion.h3>
      </div>
      <p className="our-partners-description">
        "Chauwk has established strong partnerships with top industry leaders,
        working together to foster innovation, create meaningful opportunities,
        and deliver impactful solutions that drive success and growth."
      </p>
      <div className="partners-marquee-container">
        <Marquee
          className="partners-marquee"
          speed={50}
          gradient={false}
          autoFill={true}
        >
          {companyLogos.map((logo, index) => (
            <img
              src={logo}
              alt={`Company Logo ${index + 1}`}
              className="company-logo"
              key={index}
            />
          ))}
        </Marquee>
        <Marquee
          className="partners-marquee"
          speed={40}
          gradient={false}
          direction="right"
          autoFill={true}
        >
          {companyLogos.map((logo, index) => (
            <img
              src={logo}
              alt={`Company Logo ${index + 1}`}
              className="company-logo"
              key={index}
            />
          ))}
        </Marquee>
      </div>
      <div className="image-section">
        <div className="image-1">
          <img src={FloatImg1} alt="Picture 1" />
        </div>
        <div className="image-2">
          <img src={Carpenter} alt="Picture 2" />
        </div>
        <div className="small-circle-home small-circle-1"></div>
        <div className="small-circle-home small-circle-2"></div>
        <div className="small-circle-home small-circle-3"></div>
        <div className="small-circle-home small-circle-4"></div>
        <div className="small-circle-home small-circle-5"></div>
        <div className="small-circle-home small-circle-6"></div>
        <div className="small-circle-home small-circle-7"></div>
        <div className="small-circle-home small-circle-8"></div>
      </div>
      <div className="info-section padding">
        <div className="info-section-box">
          <div className="info-item">
            <h3 className="info-heading">Fundraising for Blue-Collar Causes</h3>
            <p className="info-description">
              Welcome to Chauwk, we aim to uplift and support those who build
              our communities <br />
              through hard work and dedication.
            </p>
            <button className="click-button-getInvolved">GET INVOLVED</button>
          </div>
          <div className="info-item">
            <h3 className="info-heading">
              You Can Be a Part of Changes in Chauwk
            </h3>
            <p className="info-description">
              Join us in our mission to improve the lives of blue-collar workers
              everywhere and support, <br /> ensuring dignity and respect for
              all.
            </p>
            <button className="click-button">CLICK HERE</button>
            <div>
              <h1 className="choose">Why choose our Chauwk</h1>
            </div>
            <div className="why-choose">
              <div
                className="circle-container-three-circle-home"
                style={{ transform: "translateX(20px)" }}
              >
                <div className="circle">
                  <div
                    className="circle-back"
                    // style={{ backgroundImage: `url(${volunters3})` }}
                  ></div>
                  <div className="circle-inner">
                    <div className="circle-front">
                      <h4 className="circle-heading-why-choose">10 +</h4>
                    </div>
                  </div>
                </div>
                <h4 className="circle-heading-text">Years Experience</h4>
              </div>

              <div
                className="circle-container-three-circle-home"
                style={{ transform: "translateX(-20px)" }} // Moves left by 50px
              >
                <div className="circle">
                  <div
                    className="circle-back"
                    // style={{ backgroundImage: `url(${volunters3})` }}
                  ></div>
                  <div className="circle-inner">
                    <div className="circle-front">
                      <h4 className="circle-heading-why-choose">2K +</h4>
                    </div>
                  </div>
                </div>
                <h4 className="circle-heading-text">Volunteers</h4>
              </div>

              <div
                className="circle-containerNumeric-home "
                style={{ transform: "translateX(-50px)" }}
              >
                <div className="circle">
                  <div className="circle-back"></div>
                  <div className="circle-inner">
                    <div className="circle-front">
                      <h4 className="circle-heading-why-choose">5K +</h4>
                    </div>
                  </div>
                </div>
                <h4 className="circle-heading-text">Campaigns</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="leading">
        <motion.h3
          className="leading-animation-heading"
          initial={{ opacity: 0, y: 30 }} // Start position (hidden, shifted down)
          whileInView={{ opacity: 1, y: 0 }} // End position (fully visible, no shift)
          transition={{ duration: 1, ease: "easeInOut" }} // Smooth transition
        >
          Leading With Passion And Purpose
        </motion.h3>
        <div className="white-page">
          <div className="left-box">
            <h4>
              Direction With Our <br />
              Company
            </h4>
            <p>
              People can participate as an Enterprise, representing their brand
              and engaging with the community, or as an Enterprise User,
              exploring opportunities and contributing effectively.
            </p>
            <h5>
              <RiDoubleQuotesL size={20} className="quote-left-enterprises" />
              We work performed for Happy Clients
              <RiDoubleQuotesR size={20} className="quote-right-enterprises" />
            </h5>
            <div className="getInvolved-button-wrapper">
              <button className="primary-btn">Join as Enterprise</button>
              <button className="secondary-btn">Become Enterprise user</button>
            </div>
          </div>
          <div className="right-box">
            <img src={enterpriseLeads} alt="Leading" />
            <div className="getInvolved-stats">
              <div className="circle user-growth">
                <h3 className="stat-heading">User Growth</h3>
                <svg width="100" height="100" viewBox="0 0 100 100">
                  <circle className="circle-bg" cx="50" cy="50" r="40" />
                  <motion.circle
                    className="circle-progress"
                    cx="50"
                    cy="50"
                    r="40"
                    strokeDasharray="251.2"
                    strokeDashoffset={251.2 - (251.2 * 80) / 100}
                    initial={{ strokeDashoffset: 251.2 }}
                    animate={{ strokeDashoffset: 251.2 - (251.2 * 80) / 100 }}
                    transition={{ duration: 1.5, ease: "easeInOut" }}
                  />
                  <text
                    x="50"
                    y="55"
                    textAnchor="middle"
                    className="circle-text"
                  >
                    80%
                  </text>
                </svg>
              </div>

              <div className="circle engagement-rate">
                <h3 className="stat-heading">Engagement Rate</h3>
                <svg width="100" height="100" viewBox="0 0 100 100">
                  <circle className="circle-bg" cx="50" cy="50" r="40" />
                  <motion.circle
                    className="circle-progress"
                    cx="50"
                    cy="50"
                    r="40"
                    strokeDasharray="251.2"
                    strokeDashoffset={251.2 - (251.2 * 70) / 100}
                    initial={{ strokeDashoffset: 251.2 }}
                    animate={{ strokeDashoffset: 251.2 - (251.2 * 70) / 100 }}
                    transition={{ duration: 1.5, ease: "easeInOut" }}
                  />
                  <text
                    x="50"
                    y="55"
                    textAnchor="middle"
                    className="circle-text"
                  >
                    70%
                  </text>
                </svg>
              </div>
            </div>

            <h4 className="stat-heading-1">user Growth</h4>
            <h4 className="stat-heading-2">Active Users</h4>
          </div>
        </div>
      </div>
      <div className="digital-agency">
        <h4>DIGITAL DRIVE</h4>

        <h3>
          Step Into Digital <br />
          <span className="innovation-font">Innovation</span>with Chauwk!
        </h3>
        <div className="digital-agency-sidebox-1">
          <p>
            We are transforming the digital space with innovative solutions that
            drive success. Whether you're an individual or a business, we
            provide the tools and expertise to help you grow.
          </p>
        </div>
        <div className="digital-agency-sidebox-2">
          <p>
            Step into the future of digital excellence! Join us in building
            cutting-edge strategies, enhancing user experiences, and making
            meaningful connections in an ever-evolving digital world.
          </p>
        </div>
      </div>
      <div className="getinvolved-wrapper-boxes">
        <div className="getinvolved-box getinvolved-box-one">
          <div className="icon-circle">
            <BsPeople className="icon-style" />
          </div>
          <h5>Worker Digital Aid</h5>
          <p>Empowering individuals to connect and engage digitally.</p>
        </div>{" "}
        <div className="getinvolved-box getinvolved-box-two">
          <div className="icon-circle">
            <IoBusinessOutline className="icon-style" />
          </div>
          <h5>Enterprise Business Hub</h5>
          <p style={{ marginTop: "35px" }}>
            Helping enterprises manage their operations efficiently.
          </p>
        </div>
        <div className="getinvolved-box getinvolved-box-three">
          <div className="icon-circle">
            <AiOutlineFileSearch className="icon-style" />
          </div>
          <h5>Smart Business Solutions</h5>
          <p style={{ marginTop: "35px" }}>
            AI tools makes productivity and optimize workflows.
          </p>
        </div>
      </div>
      <div className="expand-reach text-center bg-emerald-950 py-24 px-4">
        {/* Animated Heading */}
        <motion.h3
          className="expand-reach-animation text-5xl text-yellow-50"
          initial={{ opacity: 0, y: 30 }} // Start position (hidden, moved down)
          whileInView={{ opacity: 1, y: 0 }} // End position (visible, no shift)
          transition={{ duration: 1, ease: "easeInOut" }} // Smooth transition
        >
          EXPAND YOUR REACH
        </motion.h3>
        <p>
          Expand your reach and connect with a broader audience effortlessly.
          Leverage cutting-edge digital solutions to grow your network, engage
          with new opportunities, enhance collaboration, and create a lasting
          impact in your industry.
        </p>

        <div className="expand-wrapper">
          {/* Left Side - Image Section */}
          <div className="expand-image-box" style={{ marginLeft: "-20px" }}>
            <img
              src={expandReachImage}
              alt="Expand Reach"
              className="expand-image"
            />
          </div>

          {/* Right Side - Expand Container */}
          <div className="expand-container">
            <div className="expand-row" style={{ marginTop: "-60px" }}>
              {/* <div className="expand-icon-circle"></div> */}

              <img src={hiring} alt="Hiring Icon" className="expand-icon" />

              <div className="expand-small-box expand-box-two">
                <h4>Recruiters</h4>
                <p>
                  Chauwk connects recruiters with skilled professionals
                  effortlessly.
                  <br />
                  <button className="join-here-btn">Join Here</button>
                  <IoIosArrowRoundForward className="expand-arrow-icon" />
                </p>
              </div>

              {/* <div className="expand-icon-circle-2"></div> */}

              <img
                src={businessman}
                alt="Hiring Icon"
                className="expand-icon-2"
              />

              <div className="expand-small-box expand-box-three">
                <h4>Sellers</h4>
                <p>
                  Individuals can showcase and sell products as enterprise
                  sellers.
                  <br />
                  <button className="join-here-btn">Join Here</button>
                  <IoIosArrowRoundForward className="expand-arrow-icon" />
                </p>
              </div>
            </div>

            <div className="expand-row" style={{ marginTop: "30px" }}>
              {/* <div className="expand-icon-circle-3"></div> */}

              <img src={earning} alt="Hiring Icon" className="expand-icon-3" />

              <div className="expand-small-box expand-box-five">
                <h4>Trainers</h4>
                <p>
                  Trainers can use Chauwk as a platform to share expertise and
                  reach learners.
                  <br />
                  <button
                    className="join-here-btn"
                    style={{ cursor: "pointer" }}
                  >
                    Join Here
                  </button>
                  <IoIosArrowRoundForward className="expand-arrow-icon" />
                </p>
              </div>

              <img src={trainer} alt="Hiring Icon" className="expand-icon-4" />
              {/* <div className="expand-icon-circle-4"></div> */}

              <div className="expand-small-box expand-box-six">
                <h4>HR/Admin </h4>
                <p>
                  HR department can use CHAUWK to manage Blue Collar Talent.
                  <br />
                  <button className="join-here-btn">Join Here</button>
                  <IoIosArrowRoundForward className="expand-arrow-icon" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="client-reviews">
        {/* Review Box with Smooth Sliding Effect */}
        <div className="review-box-1">
          <h4
            className="review-box-1-heading"
            style={{
              fontSize: "30px",
              fontWeight: "bold",
              color: "#094989",
              marginBottom: "10px",
              marginTop: "20px",
              textAlign: "center",
            }}
          >
            Trusted by Businesses, Inspired by Success
          </h4>
          <p
            style={{
              fontSize: "16px",
              color: "#333",
              textAlign: "center",
              marginBottom: "10px",
              marginTop: "25px",
              marginLeft: "80px",
              marginRight: "90px",
            }}
          >
            At Chauwk, we empower businesses with cutting-edge solutions. Hear
            from our clients about how we’ve helped them innovate, scale, and
            succeed!
          </p>
          {/* <button
            className="prev-btn"
            onClick={() =>
              setCurrentIndex((prev) =>
                prev > 0 ? prev - 1 : reviews.length - 1
              )
            }
          >
            ❮
          </button> */}

          <div
            className="reviews-slider"
            style={{
              transform: `translateX(-${
                currentIndex * (100 / reviews.length)
              }%)`,
            }}
          >
            {reviews.map((review, index) => (
              <div className="client-box" key={index}>
                <div className="client-circle"></div>
                <p className="client-name">{review.name}</p>
                <p className="client-feedback">"{review.feedback}"</p>
              </div>
            ))}
          </div>

          {/* <button
            className="next-btn"
            onClick={() =>
              setCurrentIndex((prev) =>
                prev < reviews.length - 1 ? prev + 1 : 0
              )
            }
          >
            ❯
          </button> */}

          {/* Dots Navigation */}
          <div className="dots">
            {reviews.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentIndex ? "active" : ""}`}
                onClick={() => setCurrentIndex(index)}
              ></span>
            ))}
          </div>
        </div>

        {/* Review Box 2 (Static Content) */}
        <div className="review-box-2">
          <h4>CLIENT REVIEWS</h4>
          <h5>
            Amazing <br />
            Responses From <br /> Our Clients
          </h5>
          <p>
            Our clients' words inspire us! Their amazing feedback fuels our
            passion for excellence, pushing us to deliver even better
            experiences every day.
          </p>
          <div className="progress-get-involved">
            <div className="progress-section-one">
              <div className="label-row">
                <span className="title-one">Active clients</span>
                <span className="percent-one">80%</span>
              </div>
              <div className="bar-one"></div>
            </div>

            <div className="progress-section-two">
              <div className="label-row">
                <span className="title-two">Brand Marketing</span>
                <span className="percent-two">60%</span>
              </div>
              <div className="bar-two"></div>
            </div>

            <button className="more-reviews-btn">More Reviews ➜</button>
          </div>
        </div>
      </div>

      <h4 className="blogs">BLOGS & NEWS</h4>
      <p className="blogs-para">
        Stay updated with the latest insights, trends, and innovations in the
        world of technology, design, and business. Explore expert opinions,
        success stories, and industry news to stay ahead in the digital
        landscape
      </p>
      <BlogsTestimonial />
      <div className="media-mentions-section">
        <h2 className="media-mentions-title">Media Mentions</h2>
        <p className="media-mentions-subtext">
          Stay tuned for various print and digital media coverage featuring
          CHAUWK.
        </p>
        <div className="media-cards">
          {/* Placeholder cards - replace with actual media links/logos later */}
          <div className="media-card">Coming Soon...</div>
          <div className="media-card">YourStory, TOI, LinkedIn, etc.</div>
          <div className="media-card">Exciting Media Coverage</div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GetInvolved;
